"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasLoaded = hasLoaded;
exports.load = load;
function getNoscriptId(id) {
  return "gtm-no-script-".concat(id);
}
function load(containerId) {
  var _first$parentNode;
  var iframe = document.createElement('iframe');
  iframe.src = "https://www.googletagmanager.com/ns.html?id=".concat(containerId);
  iframe.setAttribute('style', 'display:none;visibility:hidden');
  iframe.setAttribute('height', '0');
  iframe.setAttribute('width', '0');
  var noscript = document.createElement('noscript');
  noscript.id = getNoscriptId(containerId);
  noscript.appendChild(iframe);

  // Insert next to the first script element
  var first = document.getElementsByTagName('script')[0];
  (_first$parentNode = first.parentNode) === null || _first$parentNode === void 0 || _first$parentNode.insertBefore(noscript, first);
}
function hasLoaded(containerId) {
  var noscriptId = getNoscriptId(containerId);
  var gtmNoscript = document.getElementById(noscriptId);
  return gtmNoscript !== null;
}